/* KÔBO — Journal : filtres, vue index, image flottante, progression de lecture, sommaire */
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var norm = function (t) { return (t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); };
  var store = { get: function (k, d) { try { var v = localStorage.getItem(k); return v == null ? d : v; } catch (e) { return d; } }, set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} } };

  /* ======================= LISTE ======================= */
  var list = $('[data-j-list]');
  if (list) {
    var items = $$('[data-j-item]', list), q = $('[data-j-q]', list), empty = $('[data-j-empty]', list), tag = '';
    var grid = $('[data-j-grid]', list), index = $('[data-j-index]', list);
    var apply = function () {
      var term = norm(q && q.value), shown = 0;
      items.forEach(function (it) {
        var tags = (it.dataset.tags || '').split('|'), okTag = !tag || tags.indexOf(tag) > -1, okQ = !term || norm(it.dataset.title).indexOf(term) > -1;
        it.hidden = !(okTag && okQ);
      });
      var visible = index && !index.hidden ? $$('[data-j-item]', index) : $$('[data-j-item]', grid);
      shown = visible.filter(function (i) { return !i.hidden; }).length;
      if (empty) empty.hidden = shown > 0;
    };
    $$('[data-j-tag]', list).forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); tag = a.dataset.jTag; $$('[data-j-tag]', list).forEach(function (x) { x.classList.toggle('is-on', x === a); }); apply(); });
    });
    if (q) q.addEventListener('input', apply);

    var setView = function (v) {
      var isIndex = v === 'index';
      grid.hidden = isIndex; index.hidden = !isIndex;
      $$('[data-j-view]', list).forEach(function (b) { b.classList.toggle('is-on', b.dataset.jView === v); });
      store.set('j-view', v); apply();
    };
    $$('[data-j-view]', list).forEach(function (b) { b.addEventListener('click', function () { setView(b.dataset.jView); }); });
    if (store.get('j-view', 'grid') === 'index' && window.innerWidth > 900) setView('index');

    /* image qui suit le curseur dans la vue index */
    var fl = $('[data-j-float]', list), fimg = fl && $('img', fl);
    if (fl && index && !reduce && window.matchMedia('(hover: hover)').matches) {
      var tx = 0, ty = 0, cx = 0, cy = 0, run = false;
      var loop = function () { cx += (tx - cx) * 0.14; cy += (ty - cy) * 0.14; fl.style.transform = 'translate3d(' + cx + 'px,' + cy + 'px,0) scale(1) rotate(' + ((tx - cx) * 0.05).toFixed(2) + 'deg)'; if (run) requestAnimationFrame(loop); };
      index.addEventListener('mousemove', function (e) { tx = e.clientX + 28; ty = e.clientY - 140; });
      $$('li', index).forEach(function (li) {
        li.addEventListener('mouseenter', function (e) { fimg.src = li.dataset.img; fimg.alt = li.dataset.alt || ''; fl.classList.add('is-on'); tx = cx = e.clientX + 28; ty = cy = e.clientY - 140; if (!run) { run = true; requestAnimationFrame(loop); } });
        li.addEventListener('mouseleave', function () { fl.classList.remove('is-on'); run = false; });
      });
    }
  }

  /* parallaxe (image à la une, héro d'article) */
  var para = $$('[data-j-parallax], [data-a-parallax]');
  if (para.length && !reduce) {
    var tick = false;
    var upd = function () { tick = false; var vh = window.innerHeight; para.forEach(function (img) { var box = img.parentElement.getBoundingClientRect(); if (box.bottom < -50 || box.top > vh + 50) return; var p = (box.top + box.height / 2 - vh / 2) / vh; img.style.transform = 'translate3d(0,' + (p * -7).toFixed(2) + '%,0)'; }); };
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true }); upd();
  }

  /* ======================= ARTICLE ======================= */
  var body = $('[data-a-body]');
  if (body) {
    /* sommaire */
    var toc = $('[data-a-toc]'), heads = $$('h2, h3', body);
    heads.forEach(function (h, i) { if (!h.id) h.id = 's' + (i + 1); });
    if (toc && heads.length > 1) {
      toc.innerHTML = heads.filter(function (h) { return h.tagName === 'H2'; }).map(function (h) { return '<a href="#' + h.id + '">' + h.textContent.trim() + '</a>'; }).join('');
      var links = $$('a', toc);
      var sio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { links.forEach(function (l) { l.classList.toggle('is-on', l.getAttribute('href') === '#' + e.target.id); }); } }); }, { rootMargin: '-20% 0px -70% 0px' });
      heads.filter(function (h) { return h.tagName === 'H2'; }).forEach(function (h) { sio.observe(h); });
      links.forEach(function (l) { l.addEventListener('click', function (e) { e.preventDefault(); var t = document.getElementById(l.getAttribute('href').slice(1)); if (t) window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 100, behavior: 'smooth' }); }); });
    }
    /* progression de lecture */
    var bar = $('[data-a-bar]'), pct = $('[data-a-pct]');
    var prog = function () {
      var r = body.getBoundingClientRect(), total = r.height - window.innerHeight * 0.5, done = Math.min(1, Math.max(0, (window.innerHeight * 0.4 - r.top) / total));
      if (bar) bar.style.transform = 'scaleX(' + done + ')'; if (pct) pct.textContent = Math.round(done * 100);
    };
    window.addEventListener('scroll', prog, { passive: true }); window.addEventListener('resize', prog); prog();
    /* partage / copie */
    var toast = function (m) { if (window.koboCart && window.koboCart.toast) window.koboCart.toast(m); };
    var copy = $('[data-a-copy]'); if (copy) copy.addEventListener('click', function () { if (navigator.clipboard) navigator.clipboard.writeText(location.href.split('?')[0]).then(function () { toast('Lien copié'); }); });
    var sh = $('[data-a-share]'); if (sh) sh.addEventListener('click', function () { var d = { title: document.title, url: location.href.split('?')[0] }; if (navigator.share) navigator.share(d).catch(function () {}); else if (navigator.clipboard) navigator.clipboard.writeText(d.url).then(function () { toast('Lien copié'); }); });
  }
})();
